module.exports = __webpack_public_path__ + "media/images/dummy-1895x196-dac8a3c3.png";